<template>
  <span>
    <div
      v-b-popover.hover.topright.html="getSpan( data.item.office_name , 'office' )"
      class="hover-pointer"
      @click="
        $router.push({
          name: 'set-office',
          params: { id: data.item.id }
        })
      "
    >
      <span
        v-if="data.item.office_name"
        style="font-size: smaller;"
        class="px-1"
      >
        {{ getSmallName(data.item.office_name) }}
      </span>
    </div>

  </span>
</template>

<script>
export default {
  name: 'OfficeCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    getSmallName: {
      type: Function,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
  },
}
</script>
